import React from "react";
import "../../../styles/fontSizes.scss";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import "./pageTitle.scss";
import "../../../styles/fontSizes.scss";
import Text from "../../atoms/text/text";
import OrbitPlanetDecoration from "componets/atoms/orbitPlanetDecoration";
import Bread from "../bread/bread";
//Estructura de data:
/*  
data = {title: "", subtitle: "", description: ""}
*/
// type = left o right

const PageTitle = ({ imgSrc, altImg, data, type, breadData }) => {
  const breadcrumsData = breadData;
  const imageDecoration = (
    <div className={`page-title__images`}>
      <img
        className="page-title__img page-title__img--gray"
        src={imgSrc}
        alt={altImg}
      />
      <img
        className="page-title__img page-title__img--color"
        src={imgSrc}
        alt={altImg}
      />
      <OrbitPlanetDecoration
        type={1}
        rotationZ={type == "left" || type == undefined ? "40Deg" : "180Deg"}
      />
      <OrbitPlanetDecoration
        type={2}
        rotationZ={type == "left" || type == undefined ? "80Deg" : "100Deg"}
      />
      <OrbitPlanetDecoration
        type={3}
        rotationZ={type == "left" || type == undefined ? "10Deg" : "150Deg"}
      />
    </div>
  );

  const titleText = (
    <div className="page-title__text">
      {breadcrumsData !== undefined ? (
        <Bread textSize={3} data={breadcrumsData}></Bread>
      ) : (
        "Hacen falta los datos del panel de seguimiento"
      )}
      <br />
      {data.title && (
        <Text
          fontWeight={400}
          type="h"
          textSize={6}
          color={"black"}
          className="page-title__title"
        >
          {data.title}
        </Text>
      )}
      {data.subtitle && (
        <Text
          type="h"
          textSize={5}
          color={"black"}
          className="page-title__subtitle1"
        >
          {data.subtitle}
        </Text>
      )}
      {data.subtitle2 && (
        <Text
          type="h"
          textSize={3}
          color={"black"}
          className="page-title__subtitle2"
        >
          {data.subtitle2}
        </Text>
      )}
      {data.description && (
        <ReactMarkdown className={"page-title__description"}>
          {data.description}
        </ReactMarkdown>
      )}
    </div>
  );

  return (
    <div
      className={`page-title__container page-title__container--${
        type ? type : ""
      }`}
    >
      {type === "left" ? (
        <>
          {imageDecoration}
          {titleText}
        </>
      ) : type === "right" ? (
        <>
          {titleText}
          {imageDecoration}
        </>
      ) : (
        "type incorrecto en el componente PageTitle"
      )}
    </div>
  );
};

export default PageTitle;
